export const defaultLocale = 'en-us'

export const localesList = ['en', 'en-us', 'en-ca', 'en-gb', 'en-au', 'en-nz', 'es', 'es-es', 'es-mx', 'fr', 'fr-fr', 'fr-ca']

export const supportedLocales = ['en-us', 'en-ca', 'en-gb', 'en-au', 'en-nz', 'fr-ca', 'fr-fr', 'es-es', 'es-mx']

export const getAPILocaleFromLocale = (locale: string): string => {
  switch (locale) {
    case 'en-us':
    case 'en-ca':
    case 'en-gb':
    case 'en-au':
    case 'en-nz':
      return 'en'
    case 'es-es':
    case 'es-mx':
      return 'es'
    case 'fr-fr':
    case 'fr-ca':
      return 'fr'
    default:
      return 'en'
  }
}

export const getLocaleFromPath = (url: string): string => {
  const urlParts = url.split('/').filter(Boolean)
  return localesList.includes(urlParts[0]) ? urlParts[0] : ''
}

export const getLocaleName = (locale: string): string => {
  switch (locale) {
    case 'en-us':
      return 'United States - English'
    case 'en-ca':
      return 'Canada - English'
    case 'en-gb':
      return 'United Kingdom - English'
    case 'en-au':
      return 'Australia - English'
    case 'en-nz':
      return 'New Zealand - English'
    case 'en':
      return 'English'
    case 'es-es':
      return 'España - Español'
    case 'es-mx':
      return 'México - Español'
    case 'es':
      return 'Español'
    case 'fr-fr':
      return 'France - Français'
    case 'fr-ca':
      return 'Canada - Français'
    case 'fr':
      return 'Français'
    default:
      return 'United States - English'
  }
}

export const removeLocaleFromPath = (url: string): string => {
  const urlParts = url.split('/').filter(Boolean)

  if (localesList.includes(urlParts[0])) {
    urlParts.shift()
    return `/${urlParts.join('/')}`
  }

  return url
}
